/**
 * File: apps/qbench-cp/reactapp/src/shared/components/DropdownMenu/index.js
 *
 * Purpose: Custom dropdown menu component that toggles an animated menu panel and closes on
 *     outside click or when a modal opens.
 *
 * Scope: shared/components/DropdownMenu — generic dropdown trigger/menu wrapper.
 *
 * Tags: customer-portal
 *
 * Overview: Uses useDetectOutsideClick to manage open/closed state and automatically close the
 *     menu when the user clicks outside of it, toggling open state on trigger click. Also
 *     force-closes the menu whenever the `modalOpen` prop becomes true. Renders the trigger
 *     button content passed via the `btn` prop and arbitrary `children` inside the menu panel,
 *     styled via DropdownMenuStyle.
 *
 * Dependencies: shared/hooks/misc/useDetectOutsideClick.
 *
 * Exports: default export `DropdownMenu` component.
 */

import { useEffect, useRef } from "react";
import { useDetectOutsideClick } from "shared/hooks/misc/useDetectOutsideClick";
import { DropdownMenuStyle } from "./Styles";

const DropdownMenu = ({ btn, children, modalOpen }) => {
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(dropdownRef, false);
  const onClick = () => setIsActive((prev) => !prev);

  useEffect(() => {
    if (modalOpen) {
      setIsActive(false);
    }
  }, [modalOpen, setIsActive]);
  return (
    <DropdownMenuStyle>
      <div className="menu-container">
        <button
          onClick={onClick}
          className={`menu-trigger onboarding-target-1 ${isActive ? "active" : "inactive"}`}
        >
          {btn}
        </button>
        <nav
          ref={dropdownRef}
          className={`menu ${isActive ? "active" : "inactive"}`}
        >
          {children}
        </nav>
      </div>
    </DropdownMenuStyle>
  );
};

export default DropdownMenu;
